import { createSelector, createReducer } from '@reduxjs/toolkit';

import {
  selectAllFromApiState,
  getIncludedData,
} from '../helpers/selectorHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';
import { FIELDTYPE_INCLUDE, FIELDTYPE_TYPE } from '../../constants/api';
import {
  getAllHearingsSuccess,
  getAllHearingTemplatesSuccess,
  getAllHearingTypesSuccess,
  getHearingSuccess,
  getPaginatedHearingsSuccess,
} from '../actions/api';
import { getAttr, getEntityId } from '../helpers/apiHelpers';

// -------- Overview --------

// FieldType is included in the following endpoints
//  - GET /hearingType/{hearingTypeId}/fieldTemplate
//  - GET /hearingType
//  - GET /hearing
//  - GET /hearing/{hearingId}

// -------- Reducer --------
const fieldTypeReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingTypesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypes = data.filter(
          (include) => include.type === FIELDTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypes);
      })
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypes = data.filter(
          (include) => include.type === FIELDTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypes);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypes = data.filter(
          (include) => include.type === FIELDTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypes);
      })
      .addCase(getAllHearingTemplatesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypes = data.filter(
          (include) => include.type === FIELDTYPE_TYPE,
        );
        return updateDtoList(state, 'all', fieldTypes);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypes = data.filter(
          (include) => include.type === FIELDTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypes);
      });
  },
);

// -------- Selectors --------
const selectGetAllFieldTypes = (state) =>
  selectAllFromApiState(state, 'fieldType');
const allFieldTypesSelector = createSelector(
  selectGetAllFieldTypes,
  (fieldTypes) => fieldTypes,
);
const fieldTypeEnumByIdSelector = (fieldTypeId) =>
  createSelector([allFieldTypesSelector], (fieldTypes) =>
    getAttr(
      fieldTypes.find((ft) => getEntityId(ft) === fieldTypeId),
      'fieldType',
    ),
  );

// -------- Exporting --------
export { allFieldTypesSelector, fieldTypeEnumByIdSelector };
export default fieldTypeReducer;
